module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notifications":"Notifications","notification-not-found":"Not found notifications","today":"Today","previous":"Previous"},"pt-BR":{"notifications":"Notificações","notification-not-found":"Nenhuma notificação encontrada","today":"Hoje","previous":"Anteriores"}}')
  delete Component.options._Ctor
}
